import { render, staticRenderFns } from "./RecentReportsList.vue?vue&type=template&id=086749bd&"
import script from "./RecentReportsList.vue?vue&type=script&lang=js&"
export * from "./RecentReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports